import React, { useState } from "react";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { $t } from "~/i18n.js";
import { clubHasFlight } from "~/featureMatrix.jsx";
import { DropdownMenu } from "~/components/menu/DropdownMenu.jsx";
import { ConfirmLogout } from "./ConfirmLogout.jsx";

export function MobileMenu({
  renderHeadless = false,
  showCheckDataButton = false,
  triggerShowCheckModal = () => {},
  profile = {},
  club = {},
  history = null,
  isDTOview = false,
  isAssociationview = false,
}) {
  const [showConfirmLogout, setShowConfirmLogout] = useState(false);

  const NonDTONonAss = !isAssociationview && !isDTOview;

  const menuItems = [
    // Work data button
    NonDTONonAss &&
      profile?.vliegt &&
      showCheckDataButton && {
        label: (
          <Button onClick={triggerShowCheckModal} style={{ margin: 12 }}>
            {$t("Werk gegevens bij")}
          </Button>
        ),
      },

    // First divider
    NonDTONonAss &&
      profile?.vliegt &&
      showCheckDataButton && { type: "divider" },

    {label: <Link to="/">{$t("Thuis")}</Link>},

    // Registration and reservations
    NonDTONonAss &&
      (profile?.zichzelf_aanmelden || profile?.iedereen_aanmelden) && {
        label: <Link to="/register">{$t("Aanmeldlijst")}</Link>,
      },

    NonDTONonAss &&
      clubHasFlight() &&
      (profile?.make_reservering || profile?.wijzig_reservering) && {
        label: <Link to="/reservations">{$t("Reserveren")}</Link>,
      },

    // Flight administration
    NonDTONonAss &&
      clubHasFlight() &&
      (profile?.vliegt ||
        profile?.wijzig_start ||
        profile?.wijzig_vluchten) && {
        label: <Link to="/start">{$t("Startadministratie")}</Link>,
      },

    NonDTONonAss &&
      clubHasFlight() &&
      profile?.wijzig_sleep && {
        label: <Link to="/tow">{$t("Sleepadministratie")}</Link>,
      },

    NonDTONonAss &&
      profile?.ziet_dto &&
      profile.zichzelf_aanmelden && {
        label: <Link to="/dailyreport">{$t("Dagverslagen")}</Link>,
      },

    NonDTONonAss &&
      profile?.zichzelf_aanmelden && {
        label: <Link to="/rosters">{$t("Roosters")}</Link>,
      },

    // Second divider
    { type: "divider" },

    // Material and reports
    NonDTONonAss &&
      clubHasFlight() &&
      profile?.vliegt && {
        label: <Link to="/material">{$t("Materieel")}</Link>,
      },

    NonDTONonAss &&
      clubHasFlight() &&
      profile?.vliegt && {
        label: <Link to="/report">{$t("Meldingen")}</Link>,
      },

    NonDTONonAss &&
      clubHasFlight() &&
      (profile?.wijzig_winteruren || profile?.goedkeuren_uren) && {
        label: <Link to="/maintenancehours">{$t("Onderhoudsuren")}</Link>,
      },

    // Third divider
    { type: "divider" },

    // General menu items
    !isAssociationview && {
      label: <Link to="/members">{$t("Ledenlijst")}</Link>,
    },

    !isAssociationview &&
      profile?.ziet_dto && {
        label: <Link to="/dto">{$t("DTO lijst")}</Link>,
      },

    profile?.ziet_emaillijst && {
      label: <Link to="/email">{$t("Email")}</Link>,
    },

    profile?.wijzig_news && {
      label: <Link to="/news">{$t("Nieuws")}</Link>,
    },

    !isDTOview && {
      label: <Link to="/documents">{$t("Documenten")}</Link>,
    },

    !isDTOview &&
      profile?.wijzig_findings && {
        label: <Link to="/findings">{$t("Bevindingen")}</Link>,
      },

    // Admin section
    !isDTOview && profile?.ziet_staff && { type: "divider" },

    NonDTONonAss &&
      profile?.ziet_staff &&
      clubHasFlight() && {
        label: <Link to="/admin/flights">{$t("Vluchten")}</Link>,
      },

    !isDTOview &&
      profile?.ziet_staff &&
      profile?.wijzig_leden && {
        label: <Link to="/admin/users">{$t("Gebruikers")}</Link>,
      },

    !isDTOview &&
      profile?.ziet_staff &&
      profile?.wijzig_leden && {
        label: <Link to="/admin/groups">{$t("Groepen")}</Link>,
      },

    !isDTOview &&
      profile?.ziet_staff &&
      profile?.wijzig_dto && {
        label: <Link to="/admin/competencies">{$t("Bevoegdheden")}</Link>,
      },

    !isDTOview &&
      profile?.ziet_staff &&
      (profile.wijzig_financial || profile.view_financial) && {
        label: <Link to="/admin/financial">{$t("Financieel")}</Link>,
      },

    !isDTOview &&
      profile?.ziet_staff && {
        label: <Link to="/admin/settings">{$t("Club Settings")}</Link>,
      },

    // Logout button
    !isDTOview && history && profile?.wijzig_start && { type: "divider" },
    !isDTOview &&
      history &&
      profile?.wijzig_start && {
        label: (
          <p className="clickable" onClick={() => setShowConfirmLogout(true)}>
            {$t("Uitloggen")}
          </p>
        ),
      },

    // Incident reporting button
    !isDTOview &&
      club &&
      club?.voorval_link && {
        label: (
          <Button
            target="_blank"
            rel="noopener noreferrer"
            href={club?.voorval_link}
            style={{ margin: 12 }}
          >
            {$t("Meld voorval")}
          </Button>
        ),
      },
  ].filter((f) => f);

  return (
    <div
      style={{ zIndex: 1200 }}
      className={`mobileMenu ${
        renderHeadless ? "headlessMobileMenu" : "blueBackground"
      }`}
    >
      <DropdownMenu
        trigger={
          <MenuOutlined
            style={{ fontSize: 20, color: renderHeadless ? "black" : "white" }}
          />
        }
        items={menuItems}
        alignLeft={renderHeadless ? false : true}
        maxHeight="75vh"
      />

      {ConfirmLogout && (
        <ConfirmLogout
          show={showConfirmLogout}
          closeModal={() => setShowConfirmLogout(false)}
          history={history}
        />
      )}
    </div>
  );
}
